export enum EventListenerName {
	sessionLogViewerScrollToTop = "sessionLogViewerScrollToTop",
	sessionReload = "sessionReload",
	showToursProgress = "showToursProgress",
	hideTourPopover = "hideTourPopover",
	tourPopoverReady = "tourPopoverReady",
	configTourPopoverRef = "configTourPopoverRef",
	clearTourStepListener = "clearTourStepListener",
	searchElementByTourStep = "searchElementByTourStep",
	tourElementFound = "tourElementFound",
	navigateToTourUrl = "navigateToTourUrl",
	clearTourHighlight = "clearTourHighlight",
	selectSessionActivity = "selectSessionActivity",
	displayRateLimitModal = "displayRateLimitModal",
	displayQuotaLimitModal = "displayQuotaLimitModal",
	hideQuotaLimitModal = "hideQuotaLimitModal",
	hideRateLimitModal = "hideRateLimitModal",
	sessionReloadActivity = "sessionReloadActivity",
	openChatBot = "openChatBot",
	iframeError = "iframeError",
}
